export const DATA_KEY_PROMO = 'PROMO';

/**
 * Color Drawer state management constants.
 */
export const COLOR_DRAWER_STATE_KEY = 'HDM_DRAWER_COLOR_DATA';

/**
 * Checkout state management constants.
 */
export const CHECKOUT_STATE_KEY = 'CHECKOUT_STATE';

export const HDM_COLORS_KEY = 'All_LINEA_GAMA_COLORS';
export const BACKDROP_LOADER_STATE_KEY = 'backdropLoaderState';
/**
 * Drawer state management constants.
 */
export const DRAWER_STATE_KEY = 'drawerState';

export const APPLIED_COUPON_STATE_KEY = 'appliedCouponState';

/**
 * Which of the two order pages -- cart or checkout -- is currently mounted.
 */
export const ORDER_FLOW_SOURCE_STATE_KEY = 'orderFlowSourceState';

export const GET_PHYSICAL_STORE_KEY = 'PHYSICAL_STORE_FETCH_ALL';

export const LOGIN_IDENTITY_GENERATE_COOKIES_KEY = 'LOGIN_IDENTITY_GENERATE_COOKIES';

export const ALL_ORDERS_STATUS_KEY = 'ALL_ORDERS_STATUS_KEY';
export const ORDER_STATUS_HISTORY_KEY = 'ORDER_STATUS_HISTORY_KEY';
export const ORDER_DELIVERY_DETAILS_KEY = 'ORDER_DELIVERY_DETAILS_KEY';

export const LOCATION_BY_ZIP_CODE_KEY = 'LOCATION_BY_ZIP_CODE_KEY';

export const STORE_VIEW_BY_STATES_KEY = 'STORE_VIEW_BY_STATES_KEY';

/**
 * CyberSource
 */

export const CYBERSOURCE_SAVED_CARDS_DETAILS_QUERY_KEY = 'CYBERSOURCE_SAVED_CARD_DETAILS';

/**
 * HDM Cart
 */

export const HDM_CART_MSI_FOR_PRODUCTS_QUERY_KEY = 'HDM_CART_MSI_FOR_PRODUCTS';

/**
 * PayPal
 */

export const PAYPAL_BILLING_AGREEMENT_QUERY_KEY = 'PAYPAL_BILLING_AGREEMENT';

/**
 * Gift Card
 */
export const GIFT_CARD_INQUIRY_KEY = 'giftCardInquiry';
export const GIFT_CARD_AUTHORIZATION_KEY = 'giftCardAuthorization';
export const BAZAARVOICE_QA_ACTIVE_KEY = 'BAZAARVOICE_QA_ACTIVE_KEY';
export const DATA_KEY_MULTI_FREE_GIFT_PROMO = 'MULTI_FREE_GIFT_PROMO';
